import { render, staticRenderFns } from "./AboutNews.vue?vue&type=template&id=ac306bc4&scoped=true"
import script from "./AboutNews.vue?vue&type=script&lang=js"
export * from "./AboutNews.vue?vue&type=script&lang=js"
import style0 from "./AboutNews.vue?vue&type=style&index=0&id=ac306bc4&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac306bc4",
  null
  
)

export default component.exports